import ExpertSideNavPage from '@expert/components/ExpertSideNavPage'
import { getLayoutWithSideNav } from 'routes/components/Layout'

export const getLayoutWithExpertSideNav =
  getLayoutWithSideNav(ExpertSideNavPage)
